import { Button } from '@/components/Button'

export interface AddAllocationButtonProps {
  isDisabled: boolean
  onAddAllocation: () => unknown
}

export function AddAllocationButton({
  isDisabled,
  onAddAllocation,
}: AddAllocationButtonProps) {
  return (
    <Button
      label="Add Allocation"
      isDisabled={isDisabled}
      onPress={onAddAllocation}
    />
  )
}
